// export const LIST_SERVER = "http://localhost:5000/api/log";
// export const USER_SERVER = "http://localhost:5000/api/users";
// export const CALENDAR_SERVER = "http://localhost:5000/api/calendar";

export const LIST_SERVER = "https://andthensom.herokuapp.com/api/log";
export const USER_SERVER = "https://andthensom.herokuapp.com/api/users";
export const CALENDAR_SERVER = "https://andthensom.herokuapp.com/api/calendar";
